import TableContainer from '@/components/_table-container';
import LoadingModal from '@/components/_modals/loading';
import SortList from '../../helpers/SortList';
import { mapState, mapActions } from 'vuex';
import ReportService from "../../services/ReportService";

export default {
    name: 'NewReport',
    components: { TableContainer, LoadingModal },
    data() {
        return {
            tableType: 'breeding',
            fromDate: this.$moment().subtract(2, 'weeks'),
            toDate: null,
            selectedCows: [],
            tableTypes: [
                {text: this.$t('reportPage.reportTypes.breedingReport'), value: 'breeding'},
                {text: this.$t('reportPage.reportTypes.heatReport'), value: 'heat'}
            ],
            headers: {
                breeding: [
                    { text: this.$t('cowGenerics.eartag'), sortByKey: 'Eartag' },
                    { text: this.$t('cowDetails.lactationNumber'), sortByKey: 'Lactation number' },
                    { text: this.$t('dashboardView.listHeader.daysInMilk'), sortByKey: 'DIM' },
                    { text: this.$t('cowGenerics.lastCalving'), sortByKey: 'Last calving' },
                    { text: this.$t('cowGenerics.cowLogs.Heat'), sortByKey: 'Heat time' },
                    { text: this.$t('cowGenerics.nextHeat'), sortByKey: 'Next predicted heat' },
                    { text: this.$t('cowGenerics.cowLogs.Insemination'), sortByKey: 'Insemination time' },
                    { text: this.$t('cowGenerics.nextCalving'), sortByKey: 'Next calving' },
                ],
                heat: [
                    { text: this.$t('cowGenerics.eartag'), sortByKey: 'Eartag' },
                    ...[1,2,3,4].map((v) => ([
                        { text: this.$t('cowGenerics.cowLogs.Heat'), sortByKey: 'Heat' + v },
                        { text: this.$t('cowGenerics.heatDayDiff'), sortByKey: 'heatDayDiff' + v }])).flat(),
                ]
            },
            pagination: {
                sortBy: 'eartag',
                descending: true,
                rowsPerPage: 100
            },
            sortBy: {
                key: null,
                direction: false
            },
            searchText: '',
            error: ''
        }
    },
    mounted() {
        this.getCows({include_archived: true, include_deleted: true, include_culled: true});
    },
    methods: {
        ...mapActions("reports", {
            listReports: "listReports"
        }),
        ...mapActions('cows', {
            getCows: 'getCows',
            clearCows: 'clearCows'
        }),
        flushErrors() {
            this.error = '';
        },
        validate() {
            this.flushErrors();
            // Check max 6month date range
            if (!this.fromDate) {
                this.error = this.$t('addEvent.errors.dateNeeded');
            } else if (!this.toDate) {
                if (this.$moment().diff(this.fromDate, 'months', true) > 6.05) {
                    this.error = this.$t('reportPage.errors.rangeError');
                }
            } else if (this.$moment(this.toDate).diff(this.fromDate, 'months', true) > 6.05) {
                this.error = this.$t('reportPage.errors.rangeError');
            }

            if (this.error !== '') {
                return false;
            }

            return true;
        },
        queryReport(download = false) {
            const isValidForm = this.validate();
            if (!isValidForm)
                return;

            const data = {
                fromDate: this.fromDate ? this.fromDate.format() : null,
                toDate: this.toDate ? this.toDate.format() : null,
                cow_ids: this.selectedCows,
                report_type: this.tableType
            }
            if (download) {
                ReportService.download(data)
            } else {
                this.listReports(data)
            }
        
        },
        formatDate(date) {
            if (!date)
                return '';
            return this.$moment(date).format('DD MMM YYYY');
        },
        setSortBy(sortBy) {
            this.sortBy.direction =
                !this.sortBy.direction || this.sortBy.key !== sortBy;
            this.sortBy.key = sortBy;
        },
        sortData(logs, sortBy) {
            if (!sortBy || !sortBy.key)
                return logs;
            let sortedLogs = [...logs];
            sortedLogs = SortList(sortedLogs, sortBy);
            return sortedLogs;
        },
        selectAllCow() {
            this.selectedCows = []
            this.sortedCowList.forEach(cow => {
                this.selectedCows.push(cow['cow_id'])
            })
        },
        clearAllCow() {
            this.selectedCows = []
        },
    },
    computed: {
        ...mapState({
            reportData: function (state) {
                return this.sortData(state.reports[this.tableType], this.sortBy)
            },
            sortedCowList: state => {
                return [...state.cows.cows].sort((a, b) => {
                    (a || '').eartag.localeCompare(b.eartag || '');
                });
            },
            isFetching: state => state.reports.isFetching,
        }),

    }
}


// WEBPACK FOOTER //
// ./src/components/_report/report.js